import { render, staticRenderFns } from "./PinsNotMatchingForm.vue?vue&type=template&id=30776bdc"
import script from "./PinsNotMatchingForm.vue?vue&type=script&lang=ts"
export * from "./PinsNotMatchingForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports